import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    account: {},
    isAutoUpdate: false,
    connectedInstagramUserId: null,
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    layout: '2',
    view: 'feed',
  },
  itemDesign: {},
  containerDesign: {},
};

export const instagramSlice = createSlice({
  name: 'instagram',
  initialState,
  reducers: {
    instagramStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = {
        shape: itemDesign.shape ?? 'round',
        border: itemDesign.border ?? 'none',
        borderColor: itemDesign.borderColor ?? '#000000',
        shadow: itemDesign.shadow ?? 'none',
        shadowColor: itemDesign.shadowColor ?? '#000000',
      };
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        account: blockContent.account ?? {},
        isAutoUpdate: blockContent.isAutoUpdate ?? false,
        connectedInstagramUserId: blockContent.connectedInstagramUserId ?? null,
        items: blockContent.items ?? [],
        heading: {
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };

      state.blockDesign = {
        layout: String(blockDesign.layout) ?? '2',
        view: blockDesign.view ?? 'feed',
      };
    },
    instagramClear: () => initialState,

    instagramUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    instagramUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    instagramUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    instagramUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const { instagramStore, instagramClear, instagramUpdateIsLoading, instagramUpdateIsActive, instagramUpdateBlockContent, instagramUpdateBlockDesign } =
  instagramSlice.actions;

export const selectInstagramIsLoading = (state) => state.instagram.isLoading;

export const selectInstagramId = (state) => state.instagram.id;
export const selectInstagramUID = (state) => state.instagram.uid;
export const selectInstagramSID = (state) => state.instagram.sid;

export const selectInstagramBlockContent = (state) => state.instagram.blockContent;
export const selectInstagramBlockDesign = (state) => state.instagram.blockDesign;

export const selectInstagramItemDesign = (state) => state.instagram.itemDesign;
export const selectInstagramContainerDesign = (state) => state.instagram.containerDesign;

export default instagramSlice.reducer;
